import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { logout } from "../../features/authSlice";
import { mainServiceURL } from "../defines";

export const baseQuery = fetchBaseQuery({
  baseUrl: "/",
  credentials: "include", // This ensures cookies are sent with requests
});

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  // If the query fails due to 401 (Unauthorized), try refreshing the token
  if (
    result.error &&
    (result.meta?.response?.status === 401 ||
      result.meta?.response?.status === 403)
  ) {
    try {
      // Attempt to refresh the token
      const refreshResult = await baseQuery(
        {
          url: mainServiceURL + "/login/native/refresh",
          method: "POST",
        },
        api,
        extraOptions
      );

      // If refresh succeeded, retry the original query
      if (refreshResult.data) {
        result = await baseQuery(args, api, extraOptions);
      } else {
        api.dispatch(logout());
      }
    } catch (error) {
      api.dispatch(logout());
    }
  }

  return result;
};
